// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__vhhly","lastBreadcrumb":"styles_lastBreadcrumb__eeMdM","separator":"styles_separator__J5OFf","backToHomepage":"styles_backToHomepage__SlE3I"};